import type { RouteComponentProps } from 'react-router-dom';
import type { ClipFeedClip } from '../Player/player.types';

export interface LocationState {
  clip?: ClipFeedClip;
  sampleclip?: string;
}

export interface FromSampleClipModalProps {
  clip?: ClipFeedClip;
  onClose: () => void;
}

export interface SignInProps
  extends RouteComponentProps<
    Record<string, never>,
    Record<string, never>,
    LocationState
  > {}

export interface ErrorMessage {
  message: string;
  urlText?: string;
  url?: string;
}

export enum SignInState {
  PhoneEntry = 'phoneEntry',
  OtpVerification = 'otpVerification',
  AlternativeLogin = 'alternativeLogin',
  MultipleUsers = 'multipleUsers',
  CollectUserInfo = 'collectUserInfo',
}
